import React from 'react';
import { Button } from './ui/Button';
import { BarChart3, ShieldCheck, Handshake, BookOpen } from 'lucide-react';
export function ActivitiesSection() {
  const activities = [{
    icon: <BarChart3 className="w-10 h-10 text-[#D4A843]" data-id="element-13" />,
    title: 'Дослідження ринку',
    description: 'Ми проводимо глибокий аналіз ринку, виявляємо тенденції та формуємо аналітичні звіти для покращення прозорості галузі.'
  }, {
    icon: <ShieldCheck className="w-10 h-10 text-[#D4A843]" data-id="element-14" />,
    title: 'Сертифікація та аудит',
    description: 'Допомагаємо відповідальному бізнесу впроваджувати стандарти якості та безпеки, аналізуємо відповідність грального обладнання та програмного забезпечення міжнародним стандартам'
  }, {
    icon: <Handshake className="w-10 h-10 text-[#D4A843]" data-id="element-15" />,
    title: 'Фонди та спонсорство',
    description: 'Залучаємо партнерів для підтримки соціальних ініціатив та розвитку відповідального ставлення до гри в суспільстві.'
  }, {
    icon: <BookOpen className="w-10 h-10 text-[#D4A843]" data-id="element-16" />,
    title: 'Навчальні програми',
    description: 'Організовуємо семінари, тренінги та освітні курси для підвищення обізнаності гравців та професіоналів індустрії.'
  }];
  return <section id="activities" className="py-20 bg-white" data-id="element-17">
      <div className="container mx-auto px-4" data-id="element-18">
        <div className="text-center mb-16" data-id="element-19">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-[#0A5E5C] mb-4" data-id="element-20">
            Наші чесні активності
          </h2>
          <div className="h-1 w-24 bg-[#D4A843] mx-auto rounded-full mb-6" data-id="element-21" />
          <p className="text-gray-600 text-lg max-w-2xl mx-auto" data-id="element-22">
            Ми працюємо в кількох напрямках, щоб забезпечити формування
            екосистеми, яка надасть можливість сфері азартних ігор бути більш
            чесною, прозорою та безпечною.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-23">
          {activities.map((activity, index) => <div key={index} className="bg-gray-50 rounded-xl p-8 flex flex-col items-center text-center hover:shadow-xl transition-shadow duration-300 border border-gray-100 group" data-id="element-24">
              <div className="mb-6 p-4 bg-white rounded-full shadow-sm group-hover:scale-110 transition-transform duration-300" data-id="element-25">
                {activity.icon}
              </div>
              <h3 className="text-xl font-serif font-bold text-[#0A5E5C] mb-4 min-h-[56px] flex items-center justify-center" data-id="element-26">
                {activity.title}
              </h3>
              <p className="text-gray-600 mb-8 flex-grow text-sm leading-relaxed" data-id="element-27">
                {activity.description}
              </p>
              <Button variant="primary" size="sm" className="mt-auto" data-id="element-28">
                Дізнатися більше
              </Button>
            </div>)}
        </div>
      </div>
    </section>;
}